// JavaScript code for acf_blocks/generic-text-full-image-more component
(($) => {

     "use strict";
     if ($(".acf-blocks-generic-text-full-image-more").length === 0) {
         return;
     }
     console.log("acf_blocks/generic-text-full-image-more scripts loaded...");

     $(".accordion-header", ".acf-blocks-generic-text-full-image-more").on("click", function () {
         $(this).next(".accordion-content").slideToggle();
         $(this).toggleClass("active");
     });

})(jQuery);